export default [
  // smb 申请成功
  {
    path: "smb-sales-apply-success-2026",
    name: "smbSalesApplySuccess2026",
    component: () => import("@/views/channelAgreement/twentyTwentySix/SBG/apply/applySuccess")
  },
  // smb 审批
  {
    path: "smb-sales-approve-2026",
    name: "smbSalesApprove2026",
    component: () => import("@/views/channelAgreement/twentyTwentySix/SBG/approve/index")
  },
  // smb续签
  {
    path: "smb-sales-renewal-2026",
    name: "smbSalesRenew2026",
    component: () => import("@/views/channelAgreement/twentyTwentySix/SBG/renew/renew")
  },
  // smb编辑
  {
    path: "smb-sales-edit-2026",
    name: "smbSalesEdit2026",
    component: () => import("@/views/channelAgreement/twentyTwentySix/SBG/edit/index")
  },
  // 升级列表编辑
  {
    path: "smb-sales-upgrade-edit-2026",
    name: "smbSalesUpgradeEdit2026",
    component: () => import("@/views/channelUserCen/UpgradeList/edit/index")
  },
  // smb重新提交
  {
    path: "smb-sales-resubmit-2026",
    name: "smbSalesResubmit2026",
    component: () => import("@/views/channelAgreement/twentyTwentySix/SBG/resubmit/index")
  },
  // smb渠道确认
  {
    path: "smb-sales-channel-confirm-2026",
    name: "smbSalesChannelConfirm2026",
    component: () => import("@/views/channelAgreement/twentyTwentySix/SBG/channelConfirm/channelConfirm")
  },
  // smb渠道确认成功
  {
    path: "smb-sales-channel-confirm_success-2026",
    name: "smbSalesChannelConfirmSuccess2026",
    component: () =>
      import("@/views/channelAgreement/twentyTwentySix/SBG/channelConfirm/channelConfirmSuccess")
  },
  // smb详情
  {
    path: "smb-sales-detail-2026",
    name: "smbSalesDetail2026",
    component: () => import("@/views/channelAgreement/twentyTwentySix/SBG/detail/index")
  },
  // 升级列表详情
  {
    path: "smb-sales-upgrade-detail-2026",
    name: "smbSalesUpgradeDetail2026",
    component: () => import("@/views/channelUserCen/UpgradeList/detail/index")
  },
  // Registered Instructor---签约路由
  {
    path: "registeredinstructor",
    name: "registeredinstructor",
    meta: {
      activename: "registeredinstructor"
    },
    component: () =>
      import("@/views/channelAgreement/twentyTwentySix/SBG/apply/registeredInstructor")
  },
  // Registered Instructor---详情
  {
    path: "ri-detail",
    name: "riDetail",
    meta: {
      activename: "registeredinstructor"
    },
    component: () =>
      import("@/views/channelAgreement/twentyTwentySix/SBG/registeredInstructor/detail")
  },
  // Registered Instructor---审批
  {
    path: "ri-approve",
    name: "riApprove",
    meta: {
      activename: "registeredinstructor"
    },
    component: () =>
      import("@/views/channelAgreement/twentyTwentySix/SBG/registeredInstructor/approve")
  },
  // Registered Instructor---驳回重新提交
  {
    path: "ri-resubmit",
    name: "riResubmit",
    meta: {
      activename: "registeredinstructor"
    },
    component: () =>
      import("@/views/channelAgreement/twentyTwentySix/SBG/registeredInstructor/resubmit")
  },
  // Registered Instructor---编辑
  {
    path: "ri-edit",
    name: "riEdit",
    meta: {
      activename: "registeredinstructor"
    },
    component: () =>
      import("@/views/channelAgreement/twentyTwentySix/SBG/registeredInstructor/edit")
  },
]


// WEBPACK FOOTER //
// ./src/router/smb2026.js